import { render, staticRenderFns } from "./MaintenanceCheck.vue?vue&type=template&id=f97adff4&scoped=true&"
import script from "./MaintenanceCheck.vue?vue&type=script&lang=ts&"
export * from "./MaintenanceCheck.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97adff4",
  null
  
)

export default component.exports